import React, { FC, useContext } from "react";
import DefaultButtons from "../common/buttons/DefaultButtons";
import { SchedulerCandidateContextValue } from "./context/SchedulerCandidateContext";
import { SchedulerContextValue } from "./context/SchedulerContext";

const SchedulerButtons: FC = () => {
  const { save, navigateToSession } = useContext(SchedulerContextValue);
  const { isValid } = useContext(SchedulerCandidateContextValue);

  return (
    <DefaultButtons
      onClose={navigateToSession}
      onSave={save}
      isDeleteButtonVisible={false}
      isDeleteButtonEnabled={false}
      isSaveButtonEnabled={isValid}
    />
  );
};

export default SchedulerButtons;
